import { Container, Divider, Heading } from '@chakra-ui/react';
import CardForm from 'components/ui/CardForm';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { useLocation, useParams } from 'react-router-dom';
import UserForm from '../components/UserForm';
import { useUser } from '../hooks/useUser';

export default function PageEditUser() {
  const { id } = useParams();
  const location = useLocation();
  const { data: user } = useUser(id);
  return (
    <>
      <HeaderBarInternal
        title="Editar usuário"
        backTo={`/usuarios${location.search}`}
      />
      <Divider />

      <Container 
        variant="internal"
        flexDirection="column"
      >
        <Heading as="h1" size="h1">
          Dados do usuário
          <span>Identifique um novo usuário Patri</span>
        </Heading>

        <CardForm>
          { user && <UserForm currentUser={user} /> }
        </CardForm>
      </Container>
    </>
  )
}
